import React from "react";
import Grid from '@mui/material/Grid2';
import { useParams } from "react-router-dom";
import { useStoreActions } from 'easy-peasy';
import LocalStorageService from '../../services/localStorage';
import {
    Box,
} from '@mui/material';
import './Header.css';

const localStorageService = LocalStorageService.getService();

const Header = ({isQuestionnaire}) => {
    const { orgId } = useParams();
    const policyAction = useStoreActions((actions) => actions.policy);

    const [logo, setLogo] = React.useState(null);

    const brandingInfo = localStorageService.getBrandingInfo();

    React.useEffect(() => {
        // eslint-disable-next-line eqeqeq
        if(orgId == "938125692074") {
            if (brandingInfo) {
                setLogo(JSON.parse(brandingInfo).branding)
            }
        } else {
            policyAction.getBrandingData(orgId).then(function (response) {
                setLogo(response.data && response.data.data && response.data.data.branding ? response.data.data.branding.logo && response.data.data.branding.logo : null);
            })
            .catch(function (error) {
                // console.log('Error', error);
            });
        }
    }, [orgId, policyAction, brandingInfo]);

    return (
        <Box component="section" className="headerBox">
            <Grid container className="container">
                {logo && (
                    <Grid item size={{ xs: 12, sm: 6, md: 3.3 }} style={{borderRight: '2px solid #004E87', padding: '5px 0'}} className="providers-header-logo">
                        <img src={logo} alt="BlueCross BlueSheild" style={{maxWidth: '220px'}} />
                    </Grid>
                )}
                <Grid item size={{ xs: 12, sm: 6, md: 8.7 }} className="providers-header">
                    <div className="providers-header-text" style={{paddingLeft: logo ? '32px' : '0px'}}>
                        {isQuestionnaire ? "Policy Questionnaire" : "Medical Policies"}                
                    </div>
                </Grid>
            </Grid>
        </Box>
    )

}
    

Header.propTypes = {
    isQuestionnaire: false,
};

export default Header;